<template>
	<v-layout wrap row>
		<v-flex xs12 md8>
			<v-layout wrap row>
				<v-flex xs6 md6>
					<ValidationProvider
						name="first_name"
						rules="required"
						v-slot="{ errors }"
					>
						<v-text-field
							:label="$t('First Name')"
							type="text"
							v-model="item.first_name"
							data-vv-name="first_name"
							:error-messages="errors"
							class="required"
						></v-text-field>
					</ValidationProvider>
				</v-flex>
				<v-flex xs6 md6>
					<ValidationProvider
						name="last_name"
						rules="required"
						v-slot="{ errors }"
					>
						<v-text-field
							:label="$t('Last Name')"
							type="text"
							v-model="item.last_name"
							data-vv-name="last_name"
							:error-messages="errors"
							class="required"
						></v-text-field>
					</ValidationProvider>
				</v-flex>
				<v-flex xs12 md6>
					<v-radio-group row v-model="item.gender">
						<v-radio :label="$t('Male')" value="male"></v-radio>
						<v-radio :label="$t('Female')" value="female"></v-radio>
					</v-radio-group>
				</v-flex>
				<v-flex xs6 md6>
					<ValidationProvider
						name="birthday"
						rules=""
						v-slot="{ errors }"
					>
						<v-text-field
							:label="$t('label.birthday')"
							type="date"
							v-model="item.birthday"
							data-vv-name="birthday"
							:error-messages="errors"
						></v-text-field>
					</ValidationProvider>
				</v-flex>
				<v-flex xs6 md6>
					<ValidationProvider
						name="phone"
						rules="required"
						v-slot="{ errors }"
					>
						<vue-tel-input-vuetify
							:label="$t('Phone Number')"
							type="number"
							v-model="item.phone"
							data-vv-name="phone"
							:error-messages="errors"
							class="required"
							mode="international"
							:preferredCountries="['KH']"
						></vue-tel-input-vuetify>
					</ValidationProvider>
				</v-flex>
				<v-flex xs6 md6>
					<ValidationProvider
						name="email"
						rules=""
						v-slot="{ errors }"
					>
						<v-text-field
							:label="$t('Email')"
							type="email"
							v-model="item.email"
							data-vv-name="email"
							:error-messages="errors"
						></v-text-field>
					</ValidationProvider>
				</v-flex>
				<v-flex xs6 md12>
					<ValidationProvider
						name="company_name"
						rules=""
						v-slot="{ errors }"
					>
						<v-text-field
							:label="$t('Company Name')"
							type="company_name"
							v-model="item.company_name"
							data-vv-name="company_name"
							:error-messages="errors"
						></v-text-field>
					</ValidationProvider>
				</v-flex>
				<v-flex xs6 md6>
					<ValidationProvider
						name="address"
						rules=""
						v-slot="{ errors }"
					>
						<v-text-field
							:label="$t('Address')"
							type="address"
							v-model="item.address"
							data-vv-name="address"
							:error-messages="errors"
						></v-text-field>
					</ValidationProvider>
				</v-flex>
				<v-flex xs6 md6>
					<ValidationProvider
						name="city"
						rules=""
						v-slot="{ errors }"
					>
						<v-text-field
							:label="$t('City')"
							type="city"
							v-model="item.city"
							data-vv-name="city"
							:error-messages="errors"
						></v-text-field>
					</ValidationProvider>
				</v-flex>
				<v-flex xs6 md6>
					<ValidationProvider
						name="telegram"
						rules=""
						v-slot="{ errors }"
					>
						<v-text-field
							:label="$t('Telegram')"
							type="telegram"
							v-model="item.telegram"
							data-vv-name="telegram"
							:error-messages="errors"
						></v-text-field>
					</ValidationProvider>
				</v-flex>
				<v-flex xs6 md6>
					<ValidationProvider
						name="language"
						rules=""
						v-slot="{ errors }"
					>
						<v-text-field
							:label="$t('Language')"
							type="language"
							v-model="item.language"
							data-vv-name="language"
							:error-messages="errors"
						></v-text-field>
					</ValidationProvider>
				</v-flex>
			</v-layout>
		</v-flex>
		<v-flex xs12 md4 class="pl-10">
			<v-layout row wrap>
				<v-flex xs12 md12>
					<v-card>
						<v-card-title primary-title>
							<h3>{{ $t("Profile Image") }}</h3>
						</v-card-title>
						<v-divider></v-divider>
						<v-card-text>
							<app-media-library
								v-model="item.image"
							></app-media-library>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>
<script>
export default {
	props: ["value"],

	computed: {
		item: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},
};
</script>